/**
 * @file 富文本组件
 * @author rongtan@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class RichText extends Component {
    static template = `
        <div class="rich-text-wrap">{{data | raw}}</div>
    `;
}
